/** Internal sentinel path — forces ServerErrorPage during SSR error recovery. */
export const SERVER_ERROR_SENTINEL_PATH = '/__ssr_server_error__'

/** Internal sentinel path — forces GonePage during SSR for removed newspapers. */
export const GONE_SENTINEL_PATH = '/__ssr_gone__'
